<template>
  <div class="selectTagsBox">
    <div class="title">{{title}}</div>
    <div class='content'>
      <div>
        <div class="search">
          <!-- 搜索框 -->
          <van-search
            v-model='searchValue'
            :placeholder='placeholder'
            @search='onSearch'
            @clear='onSearch'
          >
          </van-search>
        </div>
        <div v-if="Object.keys(listObj).length" class="tags">
          <div v-for="(item,key) in listObj" :key="key" class="tag pointer" :class="{active:currentObj[item[options.value]]}" @click="onChange(item)">{{item[options.name]}}</div>
        </div>
        <div v-else style="color:#999;text-align:center" class="f12">没有更多了</div>
      </div>
    </div>
    <div class='subBtnBox'>
      <div class='backSubBtn pointer left' block @click='goBack'>返回</div>
      <div class='backSubBtn pointer right' block @click='save'>确定</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    searchKey: {
      type: String,
      default: 'name'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    options: {
      type: Object,
      default: () => ({
        value: 'id',
        name: 'name'
      })
    },
    fetchApi: {
      type: Function,
      default() {}
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    defaultValue: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      listObj: {},
      currentObj: {},
      otherObj: {}, // 兼容已删除的标签
      searchValue: ''
    }
  },
  async created() {
    await this.getFetchApi()
    this.init()
  },
  methods: {
    init() {
      const { defaultValue, multiple, listObj } = this
      if (multiple) {
        if (defaultValue && Object.keys(defaultValue).length) {
          const obj = {}; const otherObj = {}
          for (const key in defaultValue) {
            if (listObj[key]) {
              obj[key] = listObj[key]
            }
            else {
              otherObj[key] = defaultValue[key]
            }
          }
          this.currentObj = obj
          this.otherObj = otherObj
        }
      }
    },
    onSearch() {
      this.getFetchApi()
    },
    getFetchApi() {
      return this.fetchApi({
        [this.searchKey]: this.searchValue
      }).then(this.thenResolve).then(res => {
        if (res && res.length) {
          const obj = {}
          res.map(item => {
            obj[item[this.options.value]] = item
          })
          this.listObj = obj
          return obj
        }
      })
    },
    onChange(item) {
      const { options, currentObj } = this
      const { value } = options
      const code = item[value]
      if (currentObj[code]) {
        this.$delete(this.currentObj, code)
      }
      else {
        this.$set(this.currentObj, code, item)
      }
    },
    goBack() {
      this.$emit('close')
    },
    save() {
      const { currentObj, otherObj } = this
      const id = Object.keys(currentObj)
      const val = Object.values(currentObj)
      const oid = Object.keys(otherObj)
      const oval = Object.values(otherObj)
      this.$emit('saveTags', [...id, ...oid], [...val, ...oval])
    }
  }
}
</script>
<style lang="less" scoped>
.selectTagsBox {
  position: fixed;
  height: 100%;
  width: 100%;
  box-sizing: border-box;;
  padding: 12px 12px 76px;
  .content {
    overflow-y: auto;
    height: calc(100%-20px);
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    .tag {
      border-radius: 2px;
      margin: 12px 12px 0 0;
      padding: 0 16px;
      font-size: 12px;
      line-height: 24px;
      background: #EEE;
      color: #666;
      &.active {
        background: rgba(0, 136, 255, 0.1);
        color: #0088FF;
      }
    }
  }
}
.subBtnBox {
  position: fixed;
  bottom: 0;
  right: 50%;
  margin-right: -50%;
  padding-top: 10px;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-around;
  background: #fff;
  .backSubBtn {
    box-sizing: border-box;
    width: 40%;
    height: 40px;
    line-height: 38px;
    text-align: center;
    border-radius:4px;
    font-size: 16px;
    font-weight: 500;
  }

  .left {
    background: #FFFFFF;
    color: #0088FF;
    border: 1px solid #0088FF;
  }

  .right {
    margin-left: 23px;
    background: #0088FF;
    color: #FFFFFF;
  }
}
</style>
